const specs = {
  zIndex: 3000,
  width: 620,
  title: {
    update: 'pages.supervisor.modal.update.single.title',
    create: 'pages.supervisor.modal.create.single.title'
  },
  okText: {
    update: 'pages.supervisor.modal.update.single.okText',
    create: 'pages.supervisor.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.supervisor.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.supervisor.fields.name.title',
        required: 'pages.supervisor.fields.name.requiredMessage',
        placeholder: 'pages.supervisor.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
